import { faHome, faMoneyBill1Wave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Card, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import auxService from "../../services/AuxService";

interface Tenant {
    id: number;
    grupo: string;
    name: string;
    data_vencimento: string;
    limite_empresas: number;
    active: boolean;
}

const initial: Tenant = {
    id: 0,
    grupo: '',
    name: '',
    data_vencimento: '',
    limite_empresas: 0,
    active: false
};

export default function LicencaIndex() {

    const [tenant, setTenant] = useState<Tenant>(initial);

    useEffect(() => {
        fetchTenant();
    }, []);

    const fetchTenant = async () => {
        auxService.getTenant().then(res => {
            setTenant(res);
        });
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100" >

            <div>
                <div className="row col-md-12 mx-auto">
                    <Form>
                        <Card className="card-primary card-outline">
                            <Card.Header className="d-flex justify-content-between">

                                <Link to="/licenca/renovar" className="">
                                    <Button variant="primary" className=""> <FontAwesomeIcon icon={faMoneyBill1Wave} /> Renovar assinatura</Button>
                                </Link>

                                <Link to="/licenca/create" className="">
                                    <Button variant="success" className=""> <FontAwesomeIcon icon={faMoneyBill1Wave} /> Comprar nova Licença</Button>
                                </Link>

                            </Card.Header>
                            <Card.Body>

                                <Table striped bordered hover >
                                    <thead className="table-light">
                                        <tr>
                                            <th>CNPJ Raiz</th>
                                            <th>Nome do Tenant</th>
                                            <th>Data de vencimento</th>
                                            <th>Limite de empresas</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider">
                                        {tenant.id > 0 && (
                                            <tr key={tenant.id}>
                                                <td>{tenant.grupo}</td>
                                                <td>{tenant.name}</td>
                                                <td>{new Date(tenant.data_vencimento).toLocaleDateString('pt-BR')}</td>
                                                <td>{tenant.limite_empresas}</td>
                                                <td>{tenant.active ? 'Ativa' : 'Inativa'}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <Card.Footer>
                                <Link to="/" className="">
                                    <Button variant="secondary" className=""> <FontAwesomeIcon icon={faHome} /> Voltar</Button>
                                </Link>
                            </Card.Footer>
                        </Card>
                    </Form>
                </div>
            </div>
        </div>

    )
}